const OPEN_MODAL = 'OPEN_MODAL';
const CLOSE_MODAL = 'CLOSE_MODAL';


export const closeModal = () => ({
  type: CLOSE_MODAL,
});

export const openModal = (text, label, action) => ({
  type: OPEN_MODAL,
  payload: {
    action: {
      text,
      label,
      action,
    },
  },
});


const initialState = {
  hidden: true,
  text: '',
  action: {
    text: '',
    label: '',
    action: undefined,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case OPEN_MODAL: {
      return {
        hidden: false,
        ...action.payload,
      };
    }
    case CLOSE_MODAL:
      // return initialState;
      return {
        hidden: true,
        action: {
          ...state.action,
          action: undefined,
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./book/src/commons/components/modal/modalDucks.js